module.exports = {"url":"https://api.ship-zone.com","filePath":"https://api.ship-zone.com"}


//////////////////
// WEBPACK FOOTER
// ./src/baseurl.json
// module id = 1073
// module chunks = 0